import React from "react";
import PageTemplate from "../../componentes/PageTemplate";

export default function Education() {
    return(
        <PageTemplate>
                <h3>Minha Formação Acadêmica</h3>
        </PageTemplate>
    )
}